module.exports = __webpack_public_path__ + "img/symbol_1.10a9dc04.png";